<h2 mat-dialog-title>Video generation</h2>
<mat-dialog-content>
  <p>To create a video, start by editing one of your existing images.</p>

  <p>Visit your gallery or public posts.</p>

  <p>
    Click
    <mat-icon class="inline-icon">add_photo_alternate</mat-icon>
    on an image to view its original request.
  </p>

  <p>
    Then click
    <mat-icon class="inline-icon">movie</mat-icon>
    <strong>Video → Generate Video</strong> to turn the image into a video.
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Cancel</button>
  <button mat-flat-button color="primary" (click)="dialogRef.close(true)">
    View gallery
  </button>
</mat-dialog-actions>
